import { css, keyframes } from "styled-components";
import { duration, easing } from "./transitions";
import { borderRadius } from "./borders";

/** Purple shimmer, matching the Figma skeleton bars (rgba(225,213,255,.35) to rgba(255,255,255,.35)). */
const sweep = keyframes`
  0%   { background-position: -866px 0; }
  100% { background-position: 866px 0; }
`;

/** A loading surface: a soft gradient sweeping across it. Reduced motion shows the still gradient. */
export const shimmerFill = css`
  background: linear-gradient(
    90deg,
    rgba(225, 213, 255, 0.35) 0%,
    rgba(255, 255, 255, 0.35) 42.788%,
    rgba(225, 213, 255, 0.35) 100%
  );
  background-size: 866px 100%;
  animation: ${sweep} 1.4s infinite linear;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

/** Text being rewritten: the old text stays, dimmed, with the shimmer sweeping over it. */
export const rewritingOverText = css`
  position: relative;
  opacity: 0.6;
  transition: opacity ${duration.normal} ${easing.smooth};

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: ${borderRadius.sm};
    pointer-events: none;
    ${shimmerFill}
  }
`;
